import { Component } from '@angular/core';
import { InformacionesGridComponent } from '../../components/informaciones/informaciones-grid/informaciones-grid.component';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-info-corporativa',
  standalone: true,
  imports: [CommonModule, InformacionesGridComponent],
  templateUrl: './info-corporativa-section.component.html',
  styleUrl: './info-corporativa-section.component.scss'
})
export class InfoCorporativaSectionComponent {

}
